import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sign-out-header',
  templateUrl: './sign-out-header.component.html',
  styleUrls: ['./sign-out-header.component.scss']
})
export class SignOutHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
